import React, { useEffect, useState } from 'react';
import theme from '../../common/color/theme';
import { CenterLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, Body3, H3, H4, H5, Name1, Text1, Text4 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import BTButton from '../../common/components/BTButton';
import { BTOutlineButton } from '../../common/components/BTOutlineButton';
import { PeoplePost, peoplePosts } from '../../common/data/PeopleData';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import '../../css/interview.css';
import { useDeviceType } from '../../hooks/useDeviceType';

type PeopleSection1rops = {
  section1Height: number;
};

const PeopleSection1 = ({ section1Height }: PeopleSection1rops) => {
  const itemCountInPage = 20;
  const { horizontal: padding } = useResponsivePadding();
  const [visibleCount, setVisibleCount] = useState(itemCountInPage);
  const [selectedPost, setSelectedPost] = useState<PeoplePost | null>(null);
  const [scrollPosY, setScrollPosY] = useState(0);
  const { isMobile } = useDeviceType();
  const [detailText, setDetailText] = useState('');

  // 뒤로가기 처리
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (selectedPost) {
        // 히스토리 back 막고 custom 동작 실행
        event.preventDefault(); // 일부 브라우저에서 무시될 수 있음
        setSelectedPost(null);
        setDetailText('');
        window.scrollTo({ top: scrollPosY, behavior: 'instant' });

        // 히스토리 "앞으로 가기" 방지
        window.history.pushState(null, '', window.location.href);
      }
    };

    window.addEventListener('popstate', handlePopState);

    // clean up
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [selectedPost, scrollPosY]);

  const handleShowMore = () => {
    setVisibleCount(prev => prev + itemCountInPage);
  };

  const visiblePosts = peoplePosts.slice(0, visibleCount);
  const hasMore = visibleCount < peoplePosts.length;

  const handleToList = () => {
    setSelectedPost(null);
    setDetailText('');
    setTimeout(() => {
      window.scrollTo({ top: scrollPosY, behavior: 'instant' as ScrollBehavior });
    }, 0);
  };

  const detailContent = () => {
    return (
      <div className="interview-page" style={{ color: 'black' }} dangerouslySetInnerHTML={{ __html: detailText }} />
    );
  };


  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(108)}`} />
      <HorizontalLayout
        style={{
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          gap: isMobile ? '4px' : '0',
        }}
      >
        <H3>We are BBTECH People</H3>
        <VerticalLayout style={{ flex: 1 }} />
        <Body1 style={{ opacity: 0.5 }} >비비테크는 기술을 넘어, 사람 중심의 혁신을 만듭니다.</Body1>
      </HorizontalLayout>

      <BTBox height={isMobile ? 30 : `${pxToRem(43)}`} />
      <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
      {!selectedPost && (
        <>
          <BTBox height={isMobile ? '35px' : `${pxToRem(141)}`} />
          <HorizontalLayout
            style={{
              flexWrap: 'wrap',
              gap: isMobile ? 35 : `${pxToRem(67)}`,
              rowGap: `${pxToRem(112)}`,
              justifyContent: 'flex-start',
            }}
          >
            {visiblePosts.map((post: PeoplePost, index: number) => (
              <VerticalLayout
                key={index}
                style={{
                  width: isMobile ? '100%' : `calc((100% - ${pxToRem(67 * 3)}) / 4)`, // 4칸 기준
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setSelectedPost(post);
                  setDetailText(post.detailText);
                  setScrollPosY(window.scrollY);
                  window.history.pushState(null, '', window.location.href);
                  window.scrollTo({ top: section1Height, behavior: 'instant' });
                }}
                data-analytics-name={`직무소개_${post.name}`}
              >
                <div style={{ position: 'relative', width: '100%' }}>
                  <VerticalLayout style={{ height: `${pxToRem(261)}` }}>
                    {/* 부서 */}
                    <Name1 style={{ color: '#14B446' }}>{post.department}</Name1>
                    <BTBox height={isMobile ? 6 : `${pxToRem(6)}`} />
                    {/* 제목 */}
                    <Body3 style={{ fontSize: isMobile ? '20px' : pxToRem(25), lineHeight: isMobile ? '28px' : pxToRem(34) }}>
                      {post.title.split('\n').map((line, i) => (
                        <React.Fragment key={i}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </Body3>
                    <BTBox height={isMobile ? 6 : `${pxToRem(15)}`} />
                    <Text4
                      style={{
                        opacity: 0.5,
                        fontSize: isMobile ? '14px' : `${pxToRem(22)}`
                      }}
                    >
                      {post.name}
                    </Text4>
                    <BTBox height={`${pxToRem(12)}`} />
                  </VerticalLayout>
                  {/* 이미지 */}
                  <img src={post.imageSrc} style={{ width: '70%', display: 'block', marginTop: `-${pxToRem(80)}`, marginLeft: 'auto', }} />
                </div>
                <VerticalLayout height={1} backgroundColor='#000000' style={{ opacity: 0.3 }}></VerticalLayout>
              </VerticalLayout>
            ))}
          </HorizontalLayout>


          {hasMore && (
            <>
              <BTBox height={`${pxToRem(176)}`} />
              <CenterLayout>
                <div style={{ width: isMobile ? '100%' : '335px' }}>
                  <BTOutlineButton
                    color="#464646"
                    borderColor="#979797"
                    centered={true}
                    onClick={handleShowMore}
                    hoverBackgroundColor={theme.colors.BIBI}
                    hoverTextDecoration='none'
                    hoverBorderColor='white'
                    hoverColor='white'
                    borderWidth={1}
                    height={isMobile ? 62 : pxToRem(102)}
                    fontSize={isMobile ? 18 : pxToRem(28)}
                    data-analytics-name="직무소개_더보기"
                  >
                    더보기
                  </BTOutlineButton>
                </div>
              </CenterLayout>
            </>
          )}
        </>
      )}

      {/* 상세 화면 */}
      {selectedPost && (
        <div style={{ width: '100%', paddingLeft: isMobile ? 0 : pxToRem(180), paddingRight: isMobile ? 0 : pxToRem(180), boxSizing: 'border-box', paddingTop: isMobile ? 0 : pxToRem(80) }}>
          <HorizontalLayout
            paddingTop={40}
            style={{ alignItems: 'center' }}
          >
            {isMobile ? (
              <>
                <VerticalLayout>
                  <H4 style={{ fontSize: '22px', lineHeight: '32px', color: theme.colors.BIBI }}>
                    {selectedPost.title.split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </H4>
                  <HorizontalLayout style={{ position: "relative", height: "226px" }}>
                    {/* 이미지 */}
                    <img
                      src={selectedPost.imageSrc}
                      style={{
                        width: "262px",
                        height: "226px",
                        objectFit: "cover",
                        position: "absolute",   // ✅ 이미지 절대 배치
                        right: "0px",          // 우측에서 16px 떨어뜨리기
                        top: "0",
                      }}
                      alt=""
                    />

                    {/* 글씨: 이미지와 겹치도록 absolute */}
                    <VerticalLayout
                      style={{
                        position: "absolute",
                        left: "0px",   // 좌측 위치
                        top: "50%",     // 세로 가운데
                        transform: "translateY(-50%)",
                        zIndex: 1,      // 이미지 위로
                        color: "white", // 이미지와 대비되게
                      }}
                    >
                      <BTBox height={20} />
                      <H5 style={{ fontSize: '17px' }} >{selectedPost.department}</H5>
                      <BTBox height={pxToRem(8)} />
                      <Text1 style={{ fontSize: '14px', opacity: 0.8 }}>{selectedPost.name}</Text1>
                    </VerticalLayout>
                  </HorizontalLayout>
                </VerticalLayout>
              </>
            ) : (
              <>
                <VerticalLayout style={{ flex: 1 }}>
                  <HorizontalLayout>
                    <VerticalLayout>
                      <BTBox height={pxToRem(100)} />
                      <H4 style={{ color: theme.colors.BIBI }}>
                        {selectedPost.title.split('\n').map((line, i) => (
                          <React.Fragment key={i}>
                            {line}
                            <br />
                          </React.Fragment>
                        ))}
                      </H4>
                      <BTBox height={pxToRem(59)} />
                      <H5>{selectedPost.department}</H5>
                      <BTBox height={pxToRem(8)} />
                      <Text1 style={{ opacity: 0.5 }}>{selectedPost.name}</Text1>
                    </VerticalLayout>
                    <img src={selectedPost.imageLargeSrc} style={{ width: `${pxToRem(451)}`, height: `${pxToRem(603)}` }} />
                  </HorizontalLayout>
                </VerticalLayout>
              </>
            )}
          </HorizontalLayout>
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
          <BTBox height={pxToRem(55)} />
          {/* 상세 내용 */}
          {detailContent()}

          <BTBox height={isMobile ? 40 : pxToRem(50)} />
          {!isMobile && (
            <>
              <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
              <BTBox height={pxToRem(131)} />
            </>
          )}

          <CenterLayout style={{ width: isMobile ? '100%' : undefined }}>
            <HorizontalLayout
              wrapContents={true}
              style={{
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '8px' : undefined, // 모바일에서는 버튼 사이 간격 줌
                alignItems: 'center',
                width: isMobile ? '100%' : undefined
              }}
            >
              <BTButton
                width={isMobile ? '100%' : `${pxToRem(313)}`}
                height={isMobile ? '60px' : `${pxToRem(100)}`}
                color='#E1E1E1'
                textColor='#707070'
                borderColor='#C2C2C2'
                hoverBorderColor='#979797'
                hoverColor='#F5F5F5'
                hoverTextColor='#464646'
                sx={{
                  fontWeight: 700,
                  fontSize: isMobile ? '15px' : `${pxToRem(28)}`,
                }}
                onClick={handleToList} data-analytics-name="직무소개_이전"
              >
                이전
              </BTButton>
            </HorizontalLayout>
          </CenterLayout>
        </div>
      )}
      <BTBox height={300} />
    </VerticalLayout>
  );
};

export default PeopleSection1;
